import { Injectable } from '@angular/core';
import { RidangoReduxAction, CardBalance } from '@ridango/core';


@Injectable()
export class CardActions {
    static SET_CARD_NUMBER = '[Card]: Set card number';
    static SET_CARD_BALANCE = '[Card]: Set card balance';
    setCardNumber ( payload: string ): RidangoReduxAction {
        return {
            type: CardActions.SET_CARD_NUMBER,
            payload: payload
        };
    }
    setBalance ( payload: CardBalance ): RidangoReduxAction {
        return {
            type: CardActions.SET_CARD_BALANCE,
            payload: payload
        };
    }
}
